import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import "./i18n/i18n";
import ProtectedRoute from "./auth/ProtectedRoute";
// import PublicRoute from "./auth/PublicRoute";

import Alpine from "alpinejs";
import persist from "@alpinejs/persist";

// Site Routes
import Home from "./pages/site/Home";
import TermsConditions from "./pages/site/registration/TermsConditions";
import Initiate from "./pages/site/registration/Initiate";
import OtpVerification from "./pages/site/registration/OtpVerification";
import SiteLayout from "./layouts/SiteLayout";
import LanguageSelect from "./pages/site/LanguageSelect";
import VerificationDocuments from "./pages/site/registration/VerificationDocuments";
import CustomerDetail from "./pages/site/registration/CustomerDetail";
import Status from "./pages/site/registration/Status";

// Admin Routes
import AdminLayout from "./layouts/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import AllRegistrations from "./pages/admin/registration/AllRegistrations";
import RegistrationDetail from "./pages/admin/registration/RegistrationDetail";
import { Toaster } from "react-hot-toast";
import Login from "./pages/admin/Login";
import AuthLayout from "./layouts/AuthLayout";
import JoinMeeting from "./pages/site/meeting/JoinMeeting";
// import StartMeeting from "./pages/admin/meeting/StartMeeting";

Alpine.plugin(persist);
window.Alpine = Alpine;
Alpine.start();

function App() {
  return (
    <BrowserRouter>
    <Toaster />
    
      <Routes>
        {/* Public Site */}

        <Route element={<SiteLayout />}>
          <Route path="/" element={<Home />}></Route>
          <Route path="/language" element={<LanguageSelect />}></Route>
          <Route path="/registration/terms-conditions" element={<TermsConditions />}></Route>
          <Route path="/registration/initiate" element={<Initiate />}></Route>
          <Route path="/registration/verify-otp" element={<OtpVerification />}></Route>
          <Route path="/registration/verification-documents" element={<VerificationDocuments />}></Route>
          <Route path="/registration/customer-detail" element={<CustomerDetail />}></Route>
          <Route path="/registration/status" element={<Status />}></Route>

          <Route path="/meeting/join/:meetingId" element={<JoinMeeting />} />
        </Route>

        {/* Auth layout */}
      {/* <Route path="/admin" element={<PublicRoute><AuthLayout /></PublicRoute>}> */}
        {/* <Route path="login" element={<Login />} /> */}
        {/* <Route element={<PublicRoute><Login path="login" /></PublicRoute>} /> */}
      {/* </Route> */}

       {/* Auth layout */}
      <Route path="/admin" element={<AuthLayout />}>
        <Route path="login" element={<Login />} />
      </Route>

      {/* Admin Site */}

        <Route path="/admin"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route path="" element={<Dashboard />} />
          <Route path="registrations" element={<AllRegistrations />} />
          <Route path="registrations/:sessionId/detail" element={<RegistrationDetail />} />
          {/* <Route path="registrations/:sessionId/meeting" element={<StartMeeting />} /> */}
        </Route>

      </Routes>

    </BrowserRouter>
  );
}

export default App;
